import './global.js';

import './includes/dropDown.js';

/* tabs */
(function () {
  $('.common-tabs-block').each(function () {
    $(this).find('.tab a').on('click', function (e) {
      e.preventDefault();

      var item = $(this).closest('.tab'),
        itemPosition = item.data('tab'),
        itemContainer = $(this).closest('.common-tabs-block'),
        currentContainer = $(this).closest('.common-tabs-block').find('div[data-tab-content="' + itemPosition + '"]');

      if (itemPosition !== $('.active').data('tab')) {
        itemContainer.find('.tab').removeClass('active');
        item.addClass('active');
        itemContainer.find('div[data-tab-content]').removeClass('active');
        currentContainer.addClass('active');
      }
    });
  });
}());


